import React from 'react';
import { chakra, Checkbox, FormControl, FormLabel, Thead } from '@chakra-ui/react';
import { Th, Tr } from './factory';
import { useTranslation } from 'react-i18next';
import { TableSortArrows } from './table-sort-arrows';

interface TableHeaderProps {
  columns: string[];
  onSelectAll: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSort: (sortColumn: string) => void;
  sortColumn: string | undefined;
  sortAscending: boolean;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  columns,
  onSort,
  sortColumn,
  sortAscending,
  onSelectAll,
}) => {
  const { t } = useTranslation();

  return (
    <Thead>
      <Tr>
        {columns.map((colName) => {
          const isColActive = colName === sortColumn;

          if (colName === 'checkboxId') {
            return (
              <th className="checkbox" key={colName}>
                <FormControl>
                  <FormLabel>{t('table.selectAll')}</FormLabel>
                  <Checkbox id={`checkbox-${colName}`} onChange={(e) => onSelectAll(e)} />
                </FormControl>
              </th>
            );
          }

          return (
            <Th color={isColActive ? 'blue.500' : 'gray.800'} key={colName}>
              <chakra.button
                bg="none"
                shadow="none"
                border="none"
                borderRadius={0}
                p={0}
                m={0}
                display="flex"
                alignItems="center"
                color="inherit"
                fontFamily="body"
                fontWeight="semibold"
                textTransform="uppercase"
                fontSize="xs"
                letterSpacing="1px"
                lineHeight="2"
                onClick={() => onSort(colName)}
                _focus={{ outline: 'none' }}
                _hover={{ cursor: 'pointer', color: 'inherit' }}
              >
                {colName}
                <TableSortArrows isActive={isColActive} isAscending={sortAscending} />
              </chakra.button>
            </Th>
          );
        })}
      </Tr>
    </Thead>
  );
};
